



























import { computed, defineComponent, PropType, ref, SetupContext, watch } from "@vue/composition-api";

import Modal from "./Modal.vue";
import Warning from "./Warning.vue";
import TextInput from "./TextInput.vue";
import Button from "./Button.vue";

export interface State {
    isOpen: boolean;
    password: string;
    error: string | null;
    isBusy: boolean;
}

interface Props {
    state: State;
}

export default defineComponent({
    name: "ModalKeystoreFilePassword",
    components: {
        Modal,
        Warning,
        TextInput,
        Button
    },
    props: { state: (Object as unknown) as PropType<State> },
    model: {
        prop: "state",
        event: "change"
    },
    setup(props: Props, context: SetupContext) {
        const input = ref<HTMLInputElement | null>(null);

        const disabled = computed(() => props.state.password === "" || props.state.password.length < 9);

        function handleModalChangeIsOpen(isOpen: boolean): void {
            if (!isOpen) props.state.error = null;
            context.emit("change", { ...props.state, isOpen });
        }

        function handleInputChange(value: string): void {
            props.state.error = null;
            context.emit("change", { ...props.state, password: value });
        }

        function handleSubmit(): void {
            context.emit("submit", props.state);
        }

        watch(
            () => props.state.isOpen,
            (newVal: boolean) => {
                if (newVal) {
                    context.emit("change", { ...props.state, password: "" });
                }
                if (newVal && input.value) {
                    // Clear input every time we reopen this modal
                    props.state.password = "";
                    input.value.focus();
                }
            }
        );

        return {
            disabled,
            handleModalChangeIsOpen,
            handleInputChange,
            handleSubmit,
            input
        };
    }
});
